<template>
  <div class="mobile-table">
    <div v-if="!data.length" class="text-center text-muted py-3">{{ $t('table-field.no-data') }}</div>

    <div
        v-for="(row, i) in data"
        :key="i"
        class="mobile-row card mb-2 p-2"
        :style="{ backgroundColor: rowClass(row) }"
        :class="{ 'cursor-pointer': rowClick }"
        @click="handleCardClick(row, $event)"
    >
      <div
          v-for="col in columns.filter(c => c && visibleColumnsState[c.key])"
          :key="col.key"
          class="d-flex align-items-center mb-1 flex-wrap"
          :style="{ backgroundColor: col.key !== 'actions' ? cellClass(row, col) : '', textAlign: col.align }"
      >

        <template v-if="col.key !== 'actions'">
          <strong class="me-2 flex-shrink-0">{{ col.title }}:</strong>
          <span style="max-width: 100%; word-break: break-word; white-space: normal;">
            <slot :name="`cell-${col.key}`" :row="row" :value="row[col.key]">
              {{ row[col.key] }}
            </slot>
          </span>
        </template>

        <template v-else>
          <div class="actions-cell">
            <button
                v-for="act in col.actions.filter(a => !a.show || a.show(row))"
                :key="act.emit"
                :class="`btn ${typeof act.class === 'function' ? act.class(row) : act.class} me-1 btn-sm`"
                @click.stop="$emit('action-click', act, row)"
            >
              <i v-if="act.icon" :class="act.icon"></i>

              <span v-if="act.label" class="ms-1">
                {{ typeof act.label === 'function' ? act.label(row) : act.label }}
              </span>
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileTable",

  emits: ['action-click', 'row-click'],

  props: {
    data: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    visibleColumnsState: { type: Object, default: () => ({}) },
    rowClass: { type: Function, default: () => () => '' },
    cellClass: { type: Function, default: () => () => '' },
    rowClick: { type: Boolean, default: false }
  },

  methods: {
    handleCardClick(row, event) {
      if (!this.rowClick) return;

      const interactive = event.target.closest('button, a, input, select, textarea, .actions-cell');
      if (interactive) return;

      this.$emit('row-click', row);
    }
  }
};
</script>

<style scoped>
.mobile-row {
  transition: all 0.15s ease;
}

.cursor-pointer {
  cursor: pointer;
}

.mobile-row.cursor-pointer:hover {
  background-color: #f5f7fa;
  transition: background 0.2s;
}

.mobile-row.cursor-pointer:active {
  transform: scale(0.99);
}
</style>